import { Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import { useKaziNavigate } from '../../../Hooks/useKaziNavigate';
import { useGetMarketplaceJobsQuery } from '../../../Redux/api/jobApi';
import { KaziJobCard } from '../../../Shared Components/Kazi/Cards/KaziJobCard';
import { IMarketplaceJob } from '../../../Types/Job';
import { IncompleteProfileModal } from './IncompleteProfileModal';
import { useState } from 'react';
import { getHasRequiredFields } from '../../../Utils/TalentUtils';
import { useUser } from '../../../Hooks/useUser';
import { AppSettings } from '../../../Utils/Settings';
import { FactCheckOutlined } from '@mui/icons-material';

interface JobMarketplaceData {
    title: string;
    items: IMarketplaceJob[];
}

export const JobMarketplace = () => {
    /* ******************** Hooks ******************** */
    const { navigateWithBack } = useKaziNavigate();
    const { user } = useUser();
    const { data: jobs, isLoading: jobsLoading, isFetching: jobsFetching } = useGetMarketplaceJobsQuery();
    /* ******************** Variables ******************** */
    //@ts-ignore
    const [showIncompleteModal, setShowIncompleteModal] = useState(!getHasRequiredFields(user));
    /* ******************** Functions ******************** */
    const formatJobs = () => {    
        if (jobs) {
            let jobTypes = new Set();
            let formattedJobs: JobMarketplaceData[] = []; 
            jobs.forEach( job => {
                if (typeof job.locator === 'string') {
                    const jobType = job?.specialization ||job?.title || 'Uncategorized'
                    if (jobTypes.has(jobType)) {
                      const idx = formattedJobs.findIndex((j: any) => j.title === jobType)
                      formattedJobs[idx].items.push(job);
                    } else {
                        jobTypes.add(jobType)
                        formattedJobs.push({title: jobType, items: [job]})
                    }
                }
            });
            return formattedJobs.sort( (a, b) => {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0
            })
        }

        return []
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    if (jobs?.length === 0) return (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
            <FactCheckOutlined sx={{fontSize: '100px', color: 'green.200'}} />
            <Typography variant="title-small">Currently, there are no jobs available.</Typography>
        </Box>
    )
    return (
        <>
            {
                jobsLoading || jobsFetching ?
                <>
                    <Grid>
                        <Skeleton variant='rectangular' sx={{height: "50px", width: "150px"}} />
                    </Grid>
                    <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                    </Grid>
                    <Grid display={'grid'} gridTemplateColumns={'repeat(3, 388px)'} marginTop={3} columnGap={4}>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                        <Skeleton variant='rectangular'sx={{height: "175px", width: "10%% important"}}/>
                    </Grid>
                </>:
                formatJobs().map((job, rowIdx) => (
                    <Grid key={job.title} width={"100%"} marginTop={2}>
                        <Grid display={"flex"} flexDirection={"row"} marginRight={'2%'}>
                            <Typography variant='lora-headline-small' display={"flex"} flex={1} >{job.title}</Typography>
                            {
                                job.items.length > 3 &&
                                <Button variant='text' onClick={() => navigateWithBack(`/marketplace/${job.title}`)}>
                                    <Typography variant='label-large' fontWeight={"bold"} display={"flex"} flex={1} justifyContent={"flex-end"}>See all</Typography>
                                </Button>
                            }
                        </Grid>
                        <Grid display={'grid'} gridTemplateColumns={'repeat(auto-fit, minmax(290px, 308px))'} marginTop={3} columnGap={4} rowGap={4}>
                            {
                                job.items.slice(0, 3).map((item: any, columnIdx: number) =>(
                                    <Grid key={`${item.title}-${rowIdx}-${columnIdx}`}>
                                            <KaziJobCard job={item} sx={{ height: '100%'}} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                ))
            }
            <IncompleteProfileModal 
                open={showIncompleteModal}
                setOpen={setShowIncompleteModal}
            />
        </>
    )
}